import i18n from "src/i18n";
import { AUTH_TYPES } from "../types/";
const changeLanguage = async(lng) => {
  await i18n.changeLanguage(lng);
  localStorage.setItem("language", lng);
};

export const login = ( access_token, userName,  role, party_id, language_code ) => 
{
  const lang = language_code === "English" ? "en" :language_code;
  changeLanguage(lang);
  
  return {
    type: AUTH_TYPES.LOGIN,
    payload: { userName, access_token, role, party_id, language_code },
  };
};

export const register = (email, password) => {
  return {
    type: AUTH_TYPES.REGISTER,
    payload: { email: email, password: password },
  };
};
